import { useEffect } from 'react';
import CustomBreadcrumbs from '../../components/common/CustomBreadcrumbs';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import RefiDocsOutputRightSide from '../../components/refiDocsOutput/RefiDocsOutputRightSide';
import {
  selectDownloadLoadingState,
  selectDocType,
  selectTransactionId,
  selectDocsFormData,
  selectDocsResponse,
  selectRefiDocsFormData
} from '../../redux-state/selectors';
import RefiDocOutputLeft from '../../components/refiDocsOutput/RefiDocOutputLeft';
import DownloadIcon from '@mui/icons-material/Download';
import DocsOutputLeftSide from '../../components/docsOutput/DocsOutputLeftSide';
import DocsOutputRightSide from '../../components/docsOutput/DocsOutputRightSide';
import SecondaryButton from '../../components/common/button/SecondaryButton';
import PrimaryButton from '../../components/common/button/PrimaryButton';
import { buildDocsSummaryPdf, uploadDocsSummaryToS3 } from '../../components/utility/docsSummaryPdf';
import { DOWNLOAD_ALL } from '../../redux-state/types';

function DocsOutput() {
  const loadingState = useSelector(selectDownloadLoadingState);
  const navigate = useNavigate();
  const docType =  useSelector(selectDocType);
  const transactionID =  useSelector(selectTransactionId);
  const simpleDocsFormData = useSelector(selectDocsFormData);
  const docsOutput = useSelector(selectDocsResponse);
  const refiDocsFormData = useSelector(selectRefiDocsFormData);

  let docsFormData = docType === "Refi-Docs"? refiDocsFormData: simpleDocsFormData
  const dispatch = useDispatch();

  // Archive the summary PDF to S3 as soon as the documents are shown, so the
  // Past Transactions zip can include it whether or not Download is clicked.
  useEffect(() => {
    uploadDocsSummaryToS3(docsFormData, docsOutput);
    // Keyed on the transaction: one upload per transaction.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [docsOutput?.["TransactionID"]]);

  const convertToPdf = async () => {
    if (!docsOutput || Object.keys(docsOutput).length === 0) {
      return;
    }

    const pdfBlob = await buildDocsSummaryPdf(docsFormData, docsOutput);

    dispatch({
      type: DOWNLOAD_ALL,
      payload: pdfBlob,
    });

    // No-op if the automatic upload above already succeeded; retries it (with
    // the PDF just built) if it failed.
    uploadDocsSummaryToS3(docsFormData, docsOutput, pdfBlob);
  };

  return (
    <div className='p-4 lg:p-8 min-h-[900px]'>
      <div className='flex flex-row justify-between'>
        <div className='mb-4'>
          <CustomBreadcrumbs title={"Documents Output"} subtitle={"Docs Output"}/>
        </div>
        <div>
          <SecondaryButton
            text="Back"
            onClick={() => navigate(-1)}
          />
        </div>
      </div>

      <div className='text-3xl font-bold text-gray-900 mb-2'> {docType === "Refi-Docs"? "Refi-Docs": "Documents"} </div>
      <div className='text-gray-600 mb-6'>{transactionID}</div>
      <div className="w-full flex justify-end mb-8">
        <PrimaryButton
          text={
            <>
              <DownloadIcon sx={{ mr: '6px' }} />
              Download
              {loadingState && (
                <span className="ml-4 animate-spin inline-block w-4 h-4 border-2 border-t-transparent border-white rounded-full mr-2" />
              )}
            </>
          }
          className={`custom-download-button`}
          disabled={loadingState}
          onClick={convertToPdf}
        />
      </div>

      <div className='flex flex-col xl:flex-row w-full gap-6'>
        <div className='w-full xl:w-1/2 min-w-0'>
         {docType==="Refi-Docs"? < RefiDocOutputLeft /> :  <DocsOutputLeftSide />}
        </div>

        <div className="hidden xl:block w-px bg-gray-300" />

        <div className='w-full xl:w-1/2 min-w-0'>
          {docType==="Refi-Docs"? <RefiDocsOutputRightSide /> :  <DocsOutputRightSide />}
        </div>
      </div>
    </div>
  );
}

export default DocsOutput;